export const fonts = {
  jumboXxLarge: "Inter",
  jumboXLarge: "Inter",
  jumboLarge: "Inter",
  jumboMedium: "Inter",
  jumboSmall: "Inter",
  headingXxLarge: "Inter",
  headingXLarge: "Inter",
  headingLarge: "Inter",
  headingMedium: "Inter",
  headingSmall: "Inter",
  headingXSmall: "Inter",
  bodyXLargeRegular: "Inter",
  bodyXLargeStrong: "Inter",
  bodyXLargeRegularStrikethrough: "Inter",
  bodyXLargeStrongStrikethrough: "Inter",
  bodyLargeRegular: "Inter",
  bodyLargeStrong: "Inter",
  bodyLargeRegularStrikethrough: "Inter",
  bodyLargeStrongStrikethrough: "Inter",
  bodyMediumRegular: "Inter",
  bodyMediumStrong: "Inter",
  bodyMediumRegularStrikethrough: "Inter",
  bodyMediumStrongStrikethrough: "Inter",
  bodySmallRegular: "Inter",
  bodySmallStrong: "Inter",
  bodySmallRegularStrikethrough: "Inter",
  bodySmallStrongStrikethrough: "Inter",
  bodyXSmallRegular: "Inter",
  bodyXSmallStrong: "Inter",
  bodyXSmallRegularStrikethrough: "Inter",
  bodyXSmallStrongStrikethrough: "Inter",
  buttonLargeRegular: "Inter",
  buttonLargeStrong: "Inter",
  buttonMediumRegular: "Inter",
  buttonMediumStrong: "Inter",
  buttonSmallRegular: "Inter",
  buttonSmallStrong: "Inter",
  buttonXSmallRegular: "Inter",
  buttonXSmallStrong: "Inter",
  metadataMedium: "Roboto Condensed",
  metadataSmall: "Roboto Condensed",
  labelMedium: "Roboto Condensed",
  labelSmall: "Roboto Condensed",
  labelXSmall: "Roboto Condensed",
};

export const colors = {
  brandGradientDefault: "linear-gradient(125deg, #61019B 0%, #005FC8 100%)",
  brandGradientColorStopsStart: "#61019B",
  brandGradientColorStopsEnd: "#005FC8",
};

export const text = {
  themeName: "Lottery",
};